// extracted by mini-css-extract-plugin
export default {"main":"AddCoupon_main__t3wjW","body":"AddCoupon_body__sfK9N","list":"AddCoupon_list__zZg8G","btn":"AddCoupon_btn__hzSOS","header":"AddCoupon_header__I1Gud"};